/* eslint-disable import/no-anonymous-default-export */
import { SET_PROFILE_USER, SET_PORTAL_TERMS_ACCEPTED } from "./actionTypes";

const initialState: any = {
  userId:null,
  name: null,
  email: null,
  companies: null,
  currentRole: null,
  currentCompany: null,
  heading: null,
  passwordExpiresAt: null,
  portalTermsAccepted: null,
  billingPolicyLatest: null,
  cuentaCorrienteSaldo: null,
};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case SET_PROFILE_USER:
      return {
        ...state,
        userId: action.payload.userId ?? action.payload.id,
        name: action.payload.name,
        email: action.payload.email,
        roles: action.payload.roles,
        companies: action.payload.companies,
        currentRole: action.payload.currentRole,
        currentCompany: action.payload.currentCompany,
        heading: action.payload.heading,
        passwordExpiresAt: action.payload.passwordExpiresAt,
        portalTermsAccepted: action.payload.portalTermsAccepted ?? state.portalTermsAccepted,
        billingPolicyLatest: action.payload.billingPolicyLatest ?? state.billingPolicyLatest,
        cuentaCorrienteSaldo: action.payload.cuentaCorrienteSaldo ?? state.cuentaCorrienteSaldo,
      };
    case SET_PORTAL_TERMS_ACCEPTED:
      return {
        ...state,
        portalTermsAccepted: action.payload,
        currentCompany: state.currentCompany
          ? {
              ...state.currentCompany,
              // Keep this as a UI convenience; backend uses billing_policy_aproved on user profile.
              accepted_portal_billing_terms: action.payload,
            }
          : state.currentCompany,
      };
    default:
      return {
        ...state,
      };
  }
};
